"use strict";
/*
 * Created on 10.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WorkflowStatusConverter_1 = require("../../workflow/conversions/WorkflowStatusConverter");

var WindowStateEnum_1 = require("../model/WindowStateEnum");
/**
 * @author MSu
 */


var WindowStatusConverter =
/*#__PURE__*/
function (_WorkflowStatusConver) {
  _inherits(WindowStatusConverter, _WorkflowStatusConver);

  function WindowStatusConverter() {
    _classCallCheck(this, WindowStatusConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowStatusConverter).call(this, WindowStateEnum_1.WindowStateEnum));
  }

  return WindowStatusConverter;
}(WorkflowStatusConverter_1.WorkflowStatusConverter);

exports.WindowStatusConverter = WindowStatusConverter;